import React from 'react';
import { AvatarImage } from '@/components/ui/avatar';
import { useStorageSignedUrl } from '@/hooks/useStorageSignedUrl';

type SignedAvatarImageProps = React.ComponentProps<typeof AvatarImage> & {
  bucket?: string;
};

export function SignedAvatarImage({ src, bucket = 'post-media', ...props }: SignedAvatarImageProps) {
  const signedUrl = useStorageSignedUrl(typeof src === 'string' ? src : null, bucket);
  return <AvatarImage {...props} src={signedUrl || undefined} />;
}
